module.exports = __webpack_public_path__ + "static/media/vehicle-big.34c2b93f.svg";